import {keyCombo} from "./key-combo";
import {globalKeys} from "./global-keys";
import {FComponent} from "./f-component";
import {and} from "../utils/fs";

interface P {
    disabled?: boolean;
    onKeyDown: (e) => void;
    keyCombo: string;
    next?: () => any;
}
interface S {
}


export class GlobalKeys extends FComponent<P,S> {
    props: any;
    constructor(props, context) {
        super(props, context);

        this.onUnmount(globalKeys.onKeyDown(and(() => !this.props.disabled, keyCombo(props.keyCombo)), (e) => {
            this.props.onKeyDown(e);
        }));
    }


    render() {
        const {next} = this.props;

        return next?.() ?? null;
    }
}
